import React from 'react';
import Modal from 'react-bootstrap/Modal';

import CustomButton from '../../CustomButton';

const AboutAiRequestsModal = ({ onHide, resetDate }) => (
	<Modal
		show
		onHide={onHide}
		centered
		dialogClassName="ai-about-modal"
	>
		<Modal.Body>
			<button type="button" className="ai-about-modal-close" aria-label="Close" onClick={onHide}>x</button>
			<div className="ai-about-modal-icon">
				<svg width="34" height="34" viewBox="0 0 28 28" fill="none" focusable="false" role="presentation">
					<path d="M14 25v-4M10.5 19.5h7M8 12.5a6 6 0 1 1 12 0c0 2.2-1.2 3.6-2.4 4.6-.7.6-1.1 1.2-1.3 1.9h-4.6c-.2-.7-.6-1.3-1.3-1.9C9.2 16.1 8 14.7 8 12.5z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			</div>
			<h3>About AI Requests</h3>
			<p>AI Requests are used when RoscoLive generates a new AI summary or refreshes an existing report with updated fleet data.</p>
			<div className="ai-about-modal-rules">
				<div className="ai-about-modal-rule"><span>{String.fromCharCode(10003)}</span><div><strong>Opening a saved summary is free</strong><small>Viewing a report that was already generated does not use another request.</small></div></div>
				<div className="ai-about-modal-rule"><span>1</span><div><strong>Generating a new summary uses 1 request</strong><small>This includes selecting a new weekly date range that has not been saved.</small></div></div>
				<div className="ai-about-modal-rule"><span>{String.fromCharCode(8635)}</span><div><strong>Regenerating uses 1 additional request</strong><small>Use this when you want the latest fleet data for the same report period.</small></div></div>
			</div>
			<div className="ai-about-modal-usage">
				<strong>5 of 34 used</strong>
				<div className="ai-progress"><span style={{ width: '15%' }} /></div>
				<small>Your monthly allowance resets on {resetDate}.</small>
			</div>
			<CustomButton variant="primary" prefix="about-ai-done" onClick={onHide}>Got it</CustomButton>
		</Modal.Body>
	</Modal>
);

export default AboutAiRequestsModal;
